module.exports = __webpack_public_path__ + "static/img/2022中国业财一体化云服务领航企业.ed5590ef.png";